import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { API } from "../App";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle } from "lucide-react";
import axios from "axios";
import { logger } from "../lib/logger";

const ChangeOrderPaymentSuccessPage = () => {
  const { changeOrderId } = useParams();
  const [searchParams] = useSearchParams();
  const [changeOrder, setChangeOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChangeOrder = async () => {
      try {
        const response = await axios.get(`${API}/change-orders/${changeOrderId}`);
        setChangeOrder(response.data);
      } catch (error) {
        logger.error("Failed to fetch change order");
      } finally {
        setLoading(false);
      }
    };
    
    fetchChangeOrder();
  }, [changeOrderId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00341d]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-100">
      {/* Header */}
      <div className="bg-[#00341d] py-6">
        <div className="max-w-3xl mx-auto px-4">
          <img 
            src="https://customer-assets.emergentagent.com/job_06366a4e-f06e-49f6-ad8a-6605b3e3cdc0/artifacts/h5dfnsjk_Logo_text_green-transparent%20background.png" 
            alt="Land ClearCo" 
            className="h-12 brightness-0 invert mx-auto"
          />
        </div>
      </div>

      {/* Content */}
      <div className="max-w-lg mx-auto px-4 py-12">
        <Card className="bg-white border border-zinc-200 shadow-sm">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            
            <h1 className="text-2xl font-bold text-[#00341d] mb-2">Payment Successful!</h1>
            
            <p className="text-zinc-600 mb-6">
              Thank you for your payment. Your change order {changeOrder?.change_order_number} has been processed successfully.
            </p>

            {changeOrder && (
              <div className="bg-zinc-50 rounded-lg p-4 mb-6 text-left">
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <span className="text-zinc-500">Change Order:</span>
                  <span className="font-medium">{changeOrder.change_order_number}</span>
                  <span className="text-zinc-500">Original Quote:</span>
                  <span className="font-medium">{changeOrder.quote_number}</span>
                  <span className="text-zinc-500">Amount Paid:</span>
                  <span className="font-medium text-green-600">
                    ${Math.floor((changeOrder.subtotal * 1.03) * 100) / 100 .toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </span>
                </div>
              </div>
            )}

            <p className="text-sm text-zinc-500 mb-6">
              A receipt has been sent to your email. If you have any questions, please don't hesitate to contact us.
            </p>

            <Link to={`/quote/${changeOrder?.quote_id}`}>
              <Button className="bg-[#00341d] hover:bg-[#002816] text-white">
                View Original Quote
              </Button>
            </Link>
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-zinc-500">
          <p>Land ClearCo, LLC | Professional Land Clearing Services</p>
        </div>
      </div>
    </div>
  );
};

export default ChangeOrderPaymentSuccessPage;
